<p>ADMIN</p>
<app-promote-to-admin-form></app-promote-to-admin-form>
<app-logout-button></app-logout-button>